












































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import CODSearchInput from '@/app/ui/views/COD/components/CODSearchInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import DropdownCheckbox from '@/app/ui/components/DropdownCheckbox/index.vue'
import { DropDownLabelValue } from '@/app/ui/components/DropdownSelect/interface'
import { Utils } from '@/app/infrastructures/misc'
import {
  PickupCorporateFilterModel,
  PickupCorporateSearchFieldOption,
  countActiveFilters,
  PickupCorporateOriginCountry
} from '../PickupCorporateFilter/index.types'
import {
  SEARCH_FIELD_OPTIONS,
  ESTIMATE_PICKUP_TIME_OPTIONS,
  ORIGIN_COUNTRY_OPTIONS,
  SPECIAL_HANDLING_OPTIONS,
  mapLabelsToBEFlags,
  mapBEFlagsToLabels,
  CANCEL_REASON_OPTIONS
} from '../PickupCorporateFilterOptions/index'
import FleetAppFilterButton from '@/app/ui/views/Pickup/components/FleetAppFilterButton/index.vue';

@Component({
  name: 'PickupCorporateFilterRow',
  components: {
    CODSearchInput,
    DropdownSelect,
    DropdownCheckbox,
    FleetAppFilterButton
  }
})
class PickupCorporateFilterRow extends Vue {
  @Prop({ type: Object, required: true })
  readonly filter!: PickupCorporateFilterModel

  @Prop({ type: Boolean, default: false })
  readonly hideOriginCountryFilter!: boolean

  @Prop({ type: Array, default: () => SEARCH_FIELD_OPTIONS })
  readonly searchFieldOptions!: PickupCorporateSearchFieldOption[]

  @Prop({ type: Array, default: () => ESTIMATE_PICKUP_TIME_OPTIONS })
  readonly estimatePickupTimeOptions!: DropDownLabelValue<string>[]

  @Prop({ type: Array, default: () => ORIGIN_COUNTRY_OPTIONS })
  readonly originCountryOptions!: DropDownLabelValue<string>[]

  @Prop({ type: Array, default: () => SPECIAL_HANDLING_OPTIONS })
  readonly specialHandlingOptions!: DropDownLabelValue<string>[]

  @Prop({ type: Array, default: () => CANCEL_REASON_OPTIONS })
  readonly cancelReasonOptions!: DropDownLabelValue<string>[]

  isPopoverOpen = false
  localKeyword = ''

  tempFilter: PickupCorporateFilterModel = {
    keyword: '',
    keywordField: 'order_id',
    estimatePickupTime: null,
    originCountry: null,
    cancelReason: [],
    specialHandling: [],
    executionPlatform: ''
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterPropChanged(val: PickupCorporateFilterModel): void {
    if (val.keyword !== undefined && val.keyword !== null) {
      this.localKeyword = val.keyword
    }
    this.tempFilter = {
      ...val,
      keyword: this.localKeyword,
      specialHandling: val.specialHandling || []
    }
  }

  get computedFilterCounter(): number {
    return countActiveFilters(this.filter, this.hideOriginCountryFilter)
  }

  get selectedSearchByOption(): PickupCorporateSearchFieldOption {
    return (
      this.searchFieldOptions.find(
        (opt) => opt.value === this.tempFilter.keywordField
      ) || this.searchFieldOptions[0]
    )
  }

  get selectedEstimatePickupTimeOption(): DropDownLabelValue<string> | null {
    if (!this.tempFilter.estimatePickupTime) return null
    return (
      this.estimatePickupTimeOptions.find(
        (opt) => opt.value === this.tempFilter.estimatePickupTime
      ) || null
    )
  }

  get selectedOriginCountryOption(): DropDownLabelValue<string> | null {
    if (!this.tempFilter.originCountry) return null
    return (
      this.originCountryOptions.find(
        (opt) => opt.value === this.tempFilter.originCountry
      ) || null
    )
  }

  get selectedSpecialHandlingLabels(): string[] {
    return mapBEFlagsToLabels(this.tempFilter.specialHandling)
  }

  get selectedCancelReasonLabels(): string[] {
    return [...this.tempFilter.cancelReason]
  }

  togglePopover(): void {
    this.isPopoverOpen = !this.isPopoverOpen
    if (this.isPopoverOpen) {
      this.tempFilter = {
        ...this.filter,
        keyword: this.localKeyword
      }
    }
  }

  closePopover(): void {
    this.isPopoverOpen = false
  }

  onFleetApp(value: string) {
    this.tempFilter.executionPlatform = value

    this.emitFilterChange()
  }

  handleSearchFieldChange(opt: PickupCorporateSearchFieldOption): void {
    if (!opt || !opt.value) return

    const currentText = this.localKeyword
    const newField = opt.value

    this.tempFilter.keywordField = newField
    this.tempFilter.keyword = currentText

    this.$emit('search-field-change', { keywordField: newField })

    this.$nextTick(() => {
      this.localKeyword = currentText
      this.emitFilterChange()
    })
  }

  handleKeywordInput(val: string): void {
    const text = val || ''
    this.localKeyword = text
    this.tempFilter.keyword = text
    this.debouncedEmitSearch()
  }

  debouncedEmitSearch = Utils.debounce(() => {
    this.emitFilterChange()
  }, 400)

  handleEstimatePickupTimeInput(opt: DropDownLabelValue<string> | null): void {
    this.tempFilter = {
      ...this.tempFilter,
      estimatePickupTime: opt?.value || null
    }
  }

  handleCancelReasonInput(cancelReason: string[]) {
    this.tempFilter = {
      ...this.tempFilter,
      cancelReason
    }
  }

  handleOriginCountryInput(opt: DropDownLabelValue<string> | null): void {
    this.tempFilter = {
      ...this.tempFilter,
      originCountry: (opt?.value as PickupCorporateOriginCountry) || null
    }
  }

  handleSpecialHandlingInput(selectedLabels: string[]): void {
    const beFlags = mapLabelsToBEFlags(selectedLabels || [])
    this.tempFilter = {
      ...this.tempFilter,
      specialHandling: beFlags
    }
  }

  handleReset(): void {
    this.tempFilter = {
      ...this.tempFilter,
      estimatePickupTime: null,
      originCountry: null,
      specialHandling: []
    }
    this.$emit('filter-reset')
    this.closePopover()
  }

  handleApplyFilter(): void {
    this.emitFilterChange()
    this.closePopover()
  }

  emitFilterChange(): void {
    const updatedModel: PickupCorporateFilterModel = {
      ...this.tempFilter,
      keyword: this.localKeyword,
      originCountry: this.hideOriginCountryFilter
        ? null
        : this.tempFilter.originCountry
    }
    this.$emit('filter-change', updatedModel)
  }
}

export default PickupCorporateFilterRow
